import { useCallback } from 'react';
import { isEqual } from 'lodash';

import { useQuerySampleEventNames } from '@ion/api';

export default function useValidateUniqueName({ sampleEventName = '' }) {
  const { sampleEventNames, loading } = useQuerySampleEventNames();

  const validateUniqueName = useCallback(
    nameFieldValue => {
      const nameIsUnchanged = isEqual(nameFieldValue.toLowerCase(), sampleEventName.toLowerCase());

      if (nameIsUnchanged) return true;

      const nameAlreadyInUse = sampleEventNames.some(({ name }) =>
        isEqual(name.toLowerCase(), nameFieldValue.toLowerCase())
      );

      return nameAlreadyInUse ? 'Name already used' : true;
    },
    [sampleEventName, sampleEventNames]
  );

  return {
    validateUniqueName,
    existingNamesLoading: loading,
  };
}
